/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExternalCalendarService {
    /**
     * @param calendarId
     * @param isActive
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppExternalCalendarToggleCalendarSyncActiveStatus(
        calendarId: string,
        isActive?: boolean,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/externalCalendar/toggleCalendarSyncActiveStatus/{calendarId}',
            path: {
                'calendarId': calendarId,
            },
            query: {
                'isActive': isActive,
            },
        });
    }
    /**
     * @param calendarId
     * @param affectsAvailability
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppExternalCalendarSetCalendarAffectsAvailability(
        calendarId: string,
        affectsAvailability?: boolean,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/externalCalendar/setCalendarAffectsAvailability/{calendarId}',
            path: {
                'calendarId': calendarId,
            },
            query: {
                'affectsAvailability': affectsAvailability,
            },
        });
    }
    /**
     * @param calendarId
     * @param color
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppExternalCalendarSetCalendarColor(
        calendarId: string,
        color?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/externalCalendar/setCalendarColor/{calendarId}',
            path: {
                'calendarId': calendarId,
            },
            query: {
                'color': color,
            },
        });
    }
    /**
     * @param calendarId
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppExternalCalendarSetWriteTargetCalendar(
        calendarId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/externalCalendar/setWriteTargetCalendar/{calendarId}',
            path: {
                'calendarId': calendarId,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppExternalCalendarClearWriteTargetCalendar(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/externalCalendar/clearWriteTargetCalendar',
        });
    }
    /**
     * @param eventId
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppExternalCalendarDeleteExternalEvent(
        eventId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/externalCalendar/deleteExternalEvent/{eventId}',
            path: {
                'eventId': eventId,
            },
        });
    }
    /**
     * @param userId
     * @returns boolean OK
     * @throws ApiError
     */
    public static getApiAppExternalCalendarGetIsConnectedByUserId(
        userId: string,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/externalCalendar/getIsConnectedByUserId/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
}
